import React from 'react';
import './index.css';
import { Link } from 'react-router-dom';

const AboutSection = () => {
  return (
    <div className="hs-section">
      <div className="hs-text">
        <p className="hs-label">Our Services</p>
        <h1 className="hs-title">Tailored Services for Exceptional Living</h1>
        <p className="hs-desc">Every Luxe Unbounded property offers more than a luxurious stay — it delivers an experience meticulously curated for comfort, convenience, and peace of mind.</p>
        <Link to='/our-services'><button className="hs-btn">Explore Our Services</button></Link>
      </div>
      <div className="hs-image">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxeunbounded%2Fvilla3.webp?alt=media&token=3b5c5d5a-0e15-41a6-9517-cf8752ea47eb"
          alt="Luxury Villa"
        />
      </div>
    </div>
  );
};

export default AboutSection;
